import numeral from 'numeral';

export const isConcreteProduct = (productDetail: any) => productDetail?.concreteFlag;

const isCXZQProduct = (shopData: any) => shopData?.sysNo === '1047548387118899707';
const formatNumber = (value: string | number, fmt: string) => {
  // eslint-disable-next-line no-param-reassign
  value = +value;
  if (!Number.isFinite(value)) {
    return '';
  }
  return numeral(value).format(fmt);
};

const formatCurrency = (value: number) => {
  var str = formatNumber(value, '0.00[000000]');
  if (str) {
    return `￥${str}`;
  }
  return '';
};

export { formatCurrency, isCXZQProduct };
